export default "__VITE_ASSET__BW76yCt0__"